import React from 'react'
import './about.css'
import SocialContact from '../../common/social-contact'

function About() {
    return (
        <div className="about">
            <div className="about-top">
                <div className="about-info">
                    Hello, I am <br/><span className="info-name">Animesh Anand</span>.<br/>
                    Passionate Web & App  Developer with excellent development & coding skills.
                </div>
                <div className="about-photo">
                    <img src={require('../../../assets/about-pic.svg').default} alt="hi"className="picture"/>
                </div>
            </div>
            <SocialContact/>
        </div>
    )
}

export default About
